import React from 'react';
import Formsy from 'formsy-react';
import createReactClass from 'create-react-class'

const BVRadio = createReactClass({
	mixins: [Formsy.Mixin],

	componentDidMount() {
		const value = this.props.value;
		this.setValue(value);
		this.setState({ value });
	},

	changeValue(value) {
		this.setValue(value);
		this.setState({ value });
	},

	render() {
		const className = 'form-group' + (this.props.className || ' ') +
			(this.showRequired() ? 'required' : this.showError() ? 'error' : '');
		const errorMessage = this.getErrorMessage();

		const { name, title, items } = this.props;
		return (
			<div className={className}>
				<label htmlFor={name} className="bv-form-label">{title}</label>
				{items.map((item, i) => (
				<div key={i} className="v-center mr-2 float-left mb-2">
					<input
						type="radio"
						name={name}
						className="mg-form bvradio-input"
						onChange={this.changeValue.bind(this, item)}
						checked={this.state.value === item}
					/>
					<div className="text-up font14 ml-1">{item.toString()}</div>
				</div>
				))
				}
				<span className='validation-error'>{errorMessage}</span>
			</div>
		);
	}

});

export default BVRadio;
